import React from 'react';
import Icon from '../AppIcon';

const WorkoutProgressIndicator = ({ 
  currentExercise = 1, 
  totalExercises = 8, 
  exerciseName = 'Bench Press',
  onPrevious,
  onNext,
  onPause
}) => {
  const progress = (currentExercise / totalExercises) * 100;

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <div>
              <p className="text-sm caption text-muted-foreground">
                Exercise {currentExercise} of {totalExercises}
              </p>
              <h3 className="text-lg font-heading font-semibold text-foreground">
                {exerciseName}
              </h3>
            </div>
            <div className="lg:hidden">
              <div className="relative w-16 h-16">
                <svg className="w-16 h-16 transform -rotate-90">
                  <circle
                    cx="32"
                    cy="32"
                    r="28"
                    stroke="var(--color-muted)"
                    strokeWidth="6"
                    fill="none"
                  />
                  <circle
                    cx="32"
                    cy="32"
                    r="28"
                    stroke="var(--color-accent)"
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray={`${2 * Math.PI * 28}`}
                    strokeDashoffset={`${2 * Math.PI * 28 * (1 - progress / 100)}`}
                    strokeLinecap="round"
                    className="transition-smooth"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-sm font-bold data-text text-foreground">
                    {Math.round(progress)}%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="relative h-3 bg-muted rounded-full overflow-hidden">
              <div 
                className="absolute top-0 left-0 h-full bg-accent rounded-full transition-smooth"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="flex justify-between mt-2">
              <span className="text-xs caption text-muted-foreground">Start</span>
              <span className="text-xs caption font-medium data-text text-foreground">
                {Math.round(progress)}% Complete
              </span>
              <span className="text-xs caption text-muted-foreground">Finish</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 lg:gap-3">
          <button
            onClick={onPrevious}
            disabled={currentExercise === 1}
            className="flex items-center justify-center h-10 w-10 lg:h-12 lg:w-12 rounded-lg bg-muted text-foreground hover:bg-primary hover:text-primary-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-smooth hover-lift press-scale"
            aria-label="Previous exercise"
          >
            <Icon name="ChevronLeft" size={20} />
          </button>

          <button
            onClick={onPause}
            className="flex items-center justify-center h-10 w-10 lg:h-12 lg:w-12 rounded-lg bg-warning text-warning-foreground hover:bg-warning/90 transition-smooth hover-lift press-scale"
            aria-label="Pause workout"
          >
            <Icon name="Pause" size={20} />
          </button>

          <button
            onClick={onNext}
            disabled={currentExercise === totalExercises}
            className="flex items-center justify-center h-10 w-10 lg:h-12 lg:w-12 rounded-lg bg-accent text-accent-foreground hover:bg-accent/90 disabled:opacity-50 disabled:cursor-not-allowed transition-smooth hover-lift press-scale"
            aria-label="Next exercise"
          >
            <Icon name="ChevronRight" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkoutProgressIndicator;